import { render, staticRenderFns } from "./facturascv2.vue?vue&type=template&id=37f57054"
import script from "./facturascv2.vue?vue&type=script&lang=js"
export * from "./facturascv2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports